import React from "react";

import { Row, Modal } from "antd";
import "./styles.scss";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { ReactComponent as Close } from "shared/assets/Close.svg";
import TabItem from "shared/components/TabBar/TabItem";
import { NAME_SPACES } from "shared/locals/constants";

const Component = ({ visible, setIsModalVisible }) => {
  const { t } = useTranslation(NAME_SPACES.HOME);

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <Modal
      visible={visible}
      width={600}
      onCancel={handleCancel}
      modalRender={() => (
        <div className={"modal-container"}>
          <div className={"space-row"}>
            <p className={"title"}>{t("NEWSCAST")}</p>
            <Close className={"close"} onClick={handleCancel} />
          </div>
          <div className={"divider"} />
          <Row>
            <TabItem text={`${t("BULLETIN")}1`} />
            <TabItem text={`${t("BULLETIN")}2`} />
          </Row>
          <p className={"subtitle"}>Jeudi 28 Avril</p>
          <p className={"description"}>{t("NEWSCAST_MESSAGE")}</p>
        </div>
      )}
    />
  );
};

Component.propTypes = {
  visible: PropTypes.bool.isRequired,
  setIsModalVisible: PropTypes.func.isRequired,
};

export default Component;
